import React from "react";
import { useStyles } from "../../../components/managementTable/styles";
import { BLUE_TWELVE, WHITE } from "../../../theme";
import { useTranslation } from "react-i18next";

export const DetailTabs = ({ user }) => {
  const { t } = useTranslation();

  const [tab, setTab] = React.useState(0);
  const classes = useStyles();
  const USER_DETAIL_TABS = [
    {
      id: 0,
      value: t("text_personal_detail"),
    },
    {
      id: 1,
      value: t("text_contact_details"),
    },
  ];
  return (
    <div>
      <div
        className={classes.thead}
        style={{
          display: "flex",
          padding: "10px 0px",
        }}
      >
        {USER_DETAIL_TABS.map(({ id, value }) => {
          return (
            <div
              key={id}
              role="presentation"
              onClick={() => {
                setTab(id);
              }}
              style={{
                padding: "5px 20px",
                fontWeight: "700",
                cursor: "pointer",
                color: id === tab ? WHITE : BLUE_TWELVE,
                fontSize: "0.9vw",
              }}
            >
              {value}
            </div>
          );
        })}
      </div>
      <div style={{ padding: "10px 20px" }}>
        {tab === 0 && (
          <div>
            <DetailItem label={t("text_first_name")} value={user?.firstName} />
            <DetailItem label={t("text_last_name")} value={user?.lastName} />
            <DetailItem
              label={t("text_date_of_birth")}
              value={user?.birth || "N/A"}
            />
            <DetailItem
              label={t("text_gender")}
              value={user?.gender || "Male"}
            />
            <DetailItem label={t("text_emirates_id_number")} value={user?.id} />
            <DetailItem
              label={t("text_nationality")}
              value={user?.nationality || "Emirates"}
            />
            <DetailItem
              label={t("text_religion")}
              value={user?.region || "Islam"}
            />
          </div>
        )}
        {tab === 1 && (
          <div>
            <DetailItem label={t("text_email")} value={user?.email} />
            <DetailItem
              label={t("text_phone_number")}
              value={"+" + user?.countryCode + user?.phone}
            />
            <DetailItem
              label={t("text_other_phone_number")}
              value={user?.otherNumber || "N/A"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const DetailItem = ({ label, value }) => {
  return (
    <div style={{ padding: "7px 0px" }}>
      <div style={{ color: "gray", fontSize: 12 }}>{label}</div>
      <div
        style={{
          fontSize: "0.85vw",
          fontWeight: 700,
          textTransform: label === "Email" ? "lowercase" : "capitalize",
        }}
      >
        {value}
      </div>
    </div>
  );
};
